import type { ApiHandlerContract } from '@sparklayer-io/spark-dash-core/types/api';
import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { DiscountApiPayload } from '../transformers';
import type { Discount } from '../types';

/**
 * A service contract to interact with a specific discount via the SparkLayer API.
 */
export interface DiscountApiContract {
  get(): Promise<Discount>;
  update(payload: DiscountApiPayload): Promise<Discount>;
  delete(): Promise<void>;
}

/**
 * A service to interact with a specific discount via the SparkLayer API.
 */
export class DiscountApi extends ApiService implements DiscountApiContract {
  constructor(
    api: ApiHandlerContract,
    private id: string,
  ) {
    super(api);
  }

  public get(): Promise<Discount> {
    return this.api.proxy<Discount>({
      method: 'GET',
      path: '/v1/discounts/{id}',
      params: { id: this.id },
    });
  }

  public update(payload: DiscountApiPayload): Promise<Discount> {
    return this.api.proxy<Discount>({
      method: 'PATCH',
      path: '/v1/discounts/{id}',
      params: { id: this.id },
      payload,
    });
  }

  public delete(): Promise<void> {
    return this.api.proxy({
      method: 'DELETE',
      path: '/v1/discounts/{id}',
      params: { id: this.id },
    });
  }
}
